import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
const Layout = () => {
    const [currentPage, setCurrentpage] = useState<string>('home');
    useEffect(() => {
        console.log(currentPage);
    }, [currentPage])
    return (
        <>
            <div className="main-body">
                <NavBar/>
                <main>
                    <Outlet />
                </main>
                <Footer/>
            </div>
        </>

    );
};

export default Layout;
